import { LeagueType } from '@/constants/Community';
import { dummy as breastfeedingClubsDummy } from '../breastfeeding-clubs-tab/dummy';

/**
 * Stable community walkthrough data so tours don't depend on real clinic/league state.
 */

// Valid UUID format so any accidental API call won't fail GUID parsing.
// These are not real entities — callers must skip network when tour data is active.
export const DUMMY_CLINIC_ID = '00000000-0000-4000-a000-0000000000c1';
export const DUMMY_LEAGUE_ID = '00000000-0000-4000-a000-0000000000e1';

export const dummyClinic = {
  id: DUMMY_CLINIC_ID,
  name: 'Sunshine Clinic',
  clinicMembers: [
    { id: 'walkthrough-member-1' },
    { id: 'walkthrough-member-2' },
    { id: 'walkthrough-member-3' },
    { id: 'walkthrough-member-4' },
  ],
  // Shape matches TeamTab mapping: leader.firstName / leader.surname (not nested under user)
  teamLeads: [
    {
      id: 'walkthrough-lead-1',
      firstName: 'Aisha',
      surname: 'Ndlovu',
    },
  ],
  league: {
    id: DUMMY_LEAGUE_ID,
    leagueTypeName: LeagueType.League,
    name: 'Demo League',
  },
  points: {
    pointsTotal: 420,
    maxPointsTotal: 600,
    leagueRanking: 2,
    points: [
      { pointsCategoryId: '1', pointsTotal: 120 },
      { pointsCategoryId: '2', pointsTotal: 100 },
      { pointsCategoryId: '3', pointsTotal: 90 },
    ],
  },
};

export const dummyLeague = {
  id: DUMMY_LEAGUE_ID,
  name: 'Demo League',
  clinics: [
    {
      clinicId: 'walkthrough-clinic-other-1',
      clinicName: 'River Clinic',
      pointsTotalForQuarter: 510,
      pointsTotalForYear: 1800,
      leagueRankingForQuarter: 1,
      leagueRankingForYear: 1,
    },
    {
      clinicId: DUMMY_CLINIC_ID,
      clinicName: dummyClinic.name,
      pointsTotalForQuarter: 420,
      pointsTotalForYear: 1500,
      leagueRankingForQuarter: 2,
      leagueRankingForYear: 2,
    },
    {
      clinicId: 'walkthrough-clinic-other-2',
      clinicName: 'Hilltop Clinic',
      pointsTotalForQuarter: 300,
      pointsTotalForYear: 1100,
      leagueRankingForQuarter: 3,
      leagueRankingForYear: 3,
    },
  ],
};

export const dummyBreastfeedingClubs = breastfeedingClubsDummy;

export const DUMMY_CLIENT_FIRST_NAME = 'Lethabo';
